import { createContext } from "react";
import { Auth0UserProfile, Auth0Callback } from "auth0-js";
import Employee from "../types/Employee";

export const UserContext = createContext({
  authenticated: false, // to check if authenticated or not
  profile: {} as Auth0UserProfile, // store all the user details
  role: "",
  loginError: "",
  initiateLogin: () => {}, // to start the login process
  handleAuthentication: (ssoLogin: boolean) => {}, // handle Auth0 login process
  logout: () => {}, // logout the user
  login: (username: string, password: string) => {}, // logout the user
  forgotPassword: (email: string, callback: Auth0Callback<any>) => {},
  tosRequired: false,
  updateTos: () => {},
  attributes: {} as Employee,
});

export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;
